import React, { memo } from 'react';

import { FILE_ICONS } from '../../constants/file';
import { SharedFilenameProps } from '../../types/SharedFilenameProps';
import { getFileBasename } from '../../utils/getFileBasename';
import { getFileExtension } from '../../utils/getFileExtension';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import { Layout } from '../Layout/Layout';
import { Link } from '../Link/Link';
import { TruncateText } from '../Text/subcomponents/TruncateText';

export const Filename = memo(
  ({ includeExtension = true, link, name, onClick }: SharedFilenameProps) => {
    const extension = getFileExtension(name);
    const icon = FILE_ICONS[extension] || 'file';
    const filename = includeExtension ? name : getFileBasename(name);

    const filenameAndIcon = (
      <Layout align="center" spacing={1}>
        <Icon label={extension} icon={icon} />
        <TruncateText color="inherit" variant="body">
          {filename}
        </TruncateText>
      </Layout>
    );

    if (link) {
      return (
        <Link shouldTruncate {...link}>
          {filenameAndIcon}
        </Link>
      );
    }

    if (onClick) {
      return (
        <Button
          PRIVATE_isPadded={false}
          variant="action"
          icon={icon}
          iconPosition="left"
          text={filename}
          onClick={onClick}
        />
      );
    }

    return filenameAndIcon;
  },
);
